import { withInstall } from '@xzx-design/utils'
import _Popup from './src/popup'

export const Popup = withInstall(_Popup)
export default Popup

export * from './src/popup'
export * from './src/types'
